import { FC, PropsWithChildren } from "react";
import styles from "./widget.module.scss";
import { css } from "../../../ui/utils";

const Widget: FC<PropsWithChildren> = ({ children }) => {
	return <div className={css(styles["container"], "pvertical phorizontal")}>{children}</div>;
};

export { Widget };
